var _circle, _circle2, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationDefaultIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 120,
    viewBox: "0 0 119 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 59.5,
    cy: 60.4688,
    r: 59.5,
    fill: "#3BA7E2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_759_8140",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 24,
    width: 73,
    height: 73
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 59.5002,
    cy: 60.4714,
    r: 36.1667,
    fill: "#3BA7E2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_759_8140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.385 96.5993C51.1556 96.5993 43.9239 96.5993 36.6945 96.5993C35.135 96.5993 35.1658 96.5949 35.1218 94.9891C34.9588 88.9998 36.3267 83.4687 40.144 78.7306C44.9482 72.7656 51.1754 69.739 58.8916 69.75C69.815 69.7677 79.9719 78.1821 81.6107 89.8391C81.8552 91.5814 81.9257 93.3436 81.8816 95.108C81.8442 96.5773 81.8508 96.5971 80.4102 96.5993C73.0663 96.6015 65.7267 96.5993 58.385 96.5993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8732 53.5961C45.8754 47.9373 49.0231 42.9833 53.7832 40.9744C59.1513 38.7078 65.0921 40.4964 68.654 45.4526C72.9405 51.4132 71.5594 60.1845 65.6538 64.5262C58.279 69.9449 47.8314 65.4689 46.1155 56.1535C45.9481 55.2526 45.8181 54.3451 45.8732 53.5961Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationDefaultIcon);
export default __webpack_public_path__ + "static/media/notification-default-icon.869edf5e898347a9584e986636e4f27f.svg";
export { ForwardRef as ReactComponent };